import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslationService } from '../../core/services/translation.service';
import { ToasterService } from '../../core/services/visual/toaster.service';
import { AuthService } from '../auth.service';
import { APP_TITLE_KEY } from '../../dashboard/dashboard.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent implements OnInit {
  done = false;

  constructor(
    private authService: AuthService,
    private toasterService: ToasterService,
    private translationService: TranslationService,
    private titlesService: Title
  ) { }

  ngOnInit() {
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.titlesService.setTitle(title);
  }

  async onRecover(email: string) {
    try {
      await this.authService.recoverPassword(email);
      this.done = true;
    } catch (error) {
      this.toasterService.showErrorTranslating('auth.recoverPassword.error');
    }
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/recover-password/recover-password.component.ts